/**
 * Who may open Admin settings (`/admin-settings`): anyone holding the
 * permission behind at least one of its sections. Each section still gates
 * itself; this only decides whether the page — and its nav entry — exists for
 * a session at all, so nobody is offered a page with nothing on it.
 *
 * A new section adds its permission here.
 */
export const ADMIN_SETTINGS_PERMISSIONS = ['escalation.manage'] as const;

export function canOpenAdminSettings(permissions: readonly string[]): boolean {
  return ADMIN_SETTINGS_PERMISSIONS.some((permission) => permissions.includes(permission));
}
